const RE_CITATION = /\[(\d{1,3})(,\s*\{ts:\d+\})?\]/g;
const RE_MARKDOWN = /(\n*^(("""+|'''+|```+)[A-Za-z0-9]*|#+ .*)$|^- |\*\*|\$\$|\||`|[-|]{3,})/gm;
function stripCitations(text) {
    return text.replace(RE_CITATION, '');
}
function stripMarkdown(text) {
    return text.replace(RE_MARKDOWN, '');
}
export function truncateText(text, maxLength) {
    // clean anything that is used as plaintext answer (preserves newlines)
    const cleanedText = stripCitations(stripMarkdown(text)).trim();
    if (cleanedText.length <= maxLength) {
        return cleanedText;
    }
    else {
        const trimmedText = cleanedText.slice(0, maxLength).trim();
        const lastSpaceIndex = trimmedText.lastIndexOf(' ');
        // check if we're cutting off in the middle of a word and adjust if so
        if (lastSpaceIndex * 2 > maxLength && lastSpaceIndex < maxLength - 1) {
            return trimmedText.slice(0, lastSpaceIndex) + '...';
        }
        return trimmedText + '...';
    }
}
//# sourceMappingURL=truncateText.js.map